import { ossUpload } from '../../api/uploadAndDownload.js';
let uid = 1;
export default class Uploader {
    constructor(option = {}) {
        // 默认配置项目
        const defaultOption = {
            wrapper: document.body,
            multiple: false,
            limit: -1,
            autoUpload: true,
            accept: '*'
        };
        // 上传成功返回的文件数据列表
        this.ossFiles = [];
        // 配置
        this.setting = Object.assign(defaultOption, option);

        // 上传接口所需参数
        this.bucket = 'srm';
        this.businessKey = '';
        this.publicRead = 1;
        this._init();
    }
    // 创建一下隐藏的上传按钮
    _initInputElement(setting) {
        const el = document.createElement('input');
        Object.entries({
            type: 'file',
            accept: setting.accept,
            multiple: setting.multiple,
            hidden: true
        }).forEach(([key, value]) => {
            el[key] = value;
        });
        return el;
    }
    // 初始化
    async _init() {
        // 已选择的上传文件列表
        this.uploadFiles = [];
        this.input = this._initInputElement(this.setting);
        // 选择文件回调
        this.changeHandler = e => {
            const files = e.target.files;
            const ret = this._callHook('choose', files);
            if (ret !== false) {
                this.loadFiles(ret || e.target.files);
            }
        };
        this.input.addEventListener('change', this.changeHandler);
        this.setting.wrapper.appendChild(this.input);
    }
    on(evt, cb) {
        if (evt && typeof cb === 'function') {
            this[`on${evt}`] = cb;
        }
        return this;
    }
    // 触发外层回调
    _callHook(evt, ...args) {
        if (evt && this[`on${evt}`]) {
            return this[`on${evt}`](...args);
        }
    }
    chooseFile() {
        this.input.value = '';
        this.input.click();
    }
    loadFiles(files) {
        if (!files) return false;

        const type = Object.prototype.toString.call(files);
        if (type === '[object FileList]') {
            files = [].slice.call(files);
        } else if (type === '[object Object]' || type === '[object File]') {
            files = [files];
        }
        // 触发文件数量限制回调
        if (this.limit !== -1 && files.length && files.length + this.uploadFiles.length > this.limit) {
            this._callHook('exceed', files);
            return false;
        }

        this.uploadFiles = this.uploadFiles.concat(files.map(file => {
            if (file.uid && file.rawFile) {
                return file;
            } else {
                return {
                    uid: uid++,
                    rawFile: file,
                    fileName: file.name,
                    size: file.size,
                    status: 'ready'
                };
            }
        }));
        // 触发上传文件change事件
        this._callHook('change', this.uploadFiles);
        this.setting.autoUpload && this.upload();
        return true;
    }
    removeFile(file) {
        const uid = file.uid || file;
        const index = this.uploadFiles.findIndex(item => item.uid === uid);
        if (index > -1) {
            this.uploadFiles.splice(index, 1);
            this._callHook('change', this.uploadFiles);
        }
    }
    clear() {
        this.uploadFiles = [];
        this._callHook('change', this.uploadFiles);
    }
    destroy() {
        this.input.removeEventListener('change', this.changeHandler);
        this.setting.wrapper.removeChild(this.input);
    }

    upload(file) {
        this.ossFiles = [];
        if (!this.uploadFiles.length && !file) return;
        if (file) {
            const target = this.uploadFiles.find(item => item.uid === file.uid || item.uid === file);
            target && target.status !== 'success' && this._post(target);
        } else {
            this.uploadFiles.forEach(file => {
                // file.status === 'ready' && this._post(file, isUseNewUploadUrl);
                this._post(file);
            });
        }
    }
    async _post(file) {
        if (!file.rawFile) return;
        try {
            ossUpload(file.rawFile, {
                bucket: this.bucket,
                businessKey: this.businessKey,
                publicRead: this.publicRead,
                callback: null
            }).then((res) => {
                if (res && +res.code === 0) {
                    res.data.downUrl = decodeURIComponent(res.data.downUrl);
                    const lastPoint = res.data.downUrl.lastIndexOf('.');
                    const lastLine = res.data.downUrl.lastIndexOf('_');
                    const lastslash = res.data.downUrl.lastIndexOf('/');
                    // res.data.id = res.data.downUrl.slice(lastLine + 1, lastPoint);
                    // 0627 OSS版本升级，使用当前时间戳作id
                    res.data.id = (new Date()).getTime();
                    res.data.localFileName = file.name;
                    res.data.type = res.data.downUrl.slice(lastPoint + 1);
                    this.ossFiles.push(res.data);
                    this._callHook('success', '上传成功', this.ossFiles, this.uploadFiles);
                }
            }).finally(() => {
                this.disabled = false;
            });
        } catch (e) {
            file.status = 'error';
            this._callHook('error', '上传失败', file, this.uploadFiles);
        }
    }
};
